import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { GIFTING_MODAL } from '../../../../brands/default/content/components/deal';
import {
  getIsChooseYourOptionsDeal,
  getIsChooseYourProductDeal,
} from '../../../../helpers/deals';
import ThemeContext from '../../../../providers/ThemeProvider';
import WowModal from '../../../WowModal';
import DealGiftButton from '../buy-buttons/DealGiftButton';
import GiftingExplained from './GiftingExplained';

export default function GiftingModal({
  columnSelection,
  deal,
  onClose,
  noButton = false,
  mainDealGiftButton,
  mainDealGiftingChooseYourOptionsButton,
  isProductPage = false,
  position,
  setShowEmptyMessage,
  setShowModal,
  rowSelection,
}) {
  const theme = useContext(ThemeContext);
  const { giftingAtBrand, giveAsAGift } = GIFTING_MODAL;

  return (
    <>
      <WowModal
        ariaLabelledBy="id-gifting-modal"
        extraClasses="gift-modal"
        setShowModal={onClose}
        showModal
        title={giftingAtBrand}
        titleClasses="gifting-modal__title"
      >
        <GiftingExplained />
        {getIsChooseYourOptionsDeal(deal) &&
          !isProductPage &&
          mainDealGiftingChooseYourOptionsButton}

        {noButton ? (
          <div
            onClick={() => {
              getIsChooseYourProductDeal(deal);
              onClose();
            }}
            onKeyDown={() => {
              getIsChooseYourProductDeal(deal);
              onClose();
            }}
            role="link"
            tabIndex="0"
          >
            {mainDealGiftButton}
          </div>
        ) : (
          <DealGiftButton
            className="gifting"
            columnSelection={columnSelection}
            deal={deal}
            isModal
            isProductPage={isProductPage}
            position={position === -1 ? 0 : position}
            rowSelection={rowSelection}
            setShowEmptyMessage={setShowEmptyMessage}
            setShowModal={setShowModal}
            text={giveAsAGift}
          />
        )}
      </WowModal>
      <style jsx>{`
        :global(.gifting-modal__title) {
          font-size: 1.5em;
          text-align: center;
          margin-top: -10px;
          transform: translate(0%, +100%);
          width: 100%;
          margin-left: 7%;
        }
        .gifting-modal__img {
          margin-top: -8px;
          width: 100%;
        }
        :global(.modal-title) {
          font-size: 1.6em;
          color: rgba(${theme.colors.primaryLight});
          text-align: center;
          transform: translate(0%, +100%);
          justify-content: center;
          align-item: center;
        }
        :global(.gift-modal .close) {
          opacity: 1;
          color: ${theme.colors.primary};
          border-radius: 50%;
          box-shadow: none;
          text-align: center;
          margin-right: 4px;
          margin-top: 0px;
        }
        :global(.gift-modal .modal-content) {
          border: ${theme.colors.primary} 2px solid;
          width: 90%;
        }
        :global(.gift-modal) {
          height: 90%;
          margin-left: 4%;
        }

        :global(.primary-button.gifting) {
          color: ${theme.colors.dealviewbutton} !important;
          background-color: #ffffff;
          border: 3px solid ${theme.colors.dealviewbutton} !important;
          width: 75%;
          margin-left: 15%;
          transform: translate(-5%, -80%);
          margin-bottom: 0px;
          font-weight: bold;
          font-size: 1.7rem;
          margin-top: 5%;
        }

        @media only screen and (max-width: ${theme.breakpoints
            .lgDown}) and (min-width: ${theme.breakpoints.smUp}) {
          :global(.gift-modal .modal-content) {
            border: ${theme.colors.primary} 4px solid;
            width: 100%;
          }
          .gifting-modal__title {
            font-size: 25px;
            text-align: center;
            transform: translate(-2%, +50%);
          }
          .gifting-modal__img {
            margin-top: -8px;
            margin-left: 0px;
            height: auto;
          }
          :global(.gift-modal) {
            height: 100%;
            margin-left: 0px;
            margin-top: 0%;
          }
          :global(.gift-modal .close) {
            opacity: 1;
            color: ${theme.colors.primary};
            border-radius: 50%;
            box-shadow: none;
            text-align: center;
            margin-right: 4px;
            margin-top: 0px;
          }
        }
        @media only screen and (min-width: ${theme.breakpoints.smUp}) {
          :global(.primary-button.gifting) {
            color: ${theme.colors.dealviewbutton} !important;
            background-color: #ffffff;
            border: 3px solid ${theme.colors.dealviewbutton} !important;
            width: 50%;
            margin-left: 27%;
            transform: translate(-5%, -100%);
            margin-bottom: 0px;
            font-size: 2.5rem;
            font-weight: bold;
            margin-top: 5%;
          }
          :global(.gifting-modal__title) {
            font-size: 2.1em;
            text-align: center;
            margin-top: -10px;
            transform: translate(0%, +100%);
            width: 100%;
            margin-left: 7%;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.lgUp}) {
          :global(.gift-modal .modal-content) {
            border: ${theme.colors.primary} 4px solid;
            width: 150%;
          }
          .gifting-modal__title {
            font-size: 30px;
            text-align: center;
            margin-top: -10px;
            transform: translate(-2%, +50%);
            margin-left: 3%;
          }
          .gifting-modal__img {
            margin-top: -8px;
            margin-left: 0px;
            height: auto;
          }
          :global(.gift-modal) {
            height: 100%;
            margin-left: -120px;
            margin-top: 0%;
          }
          :global(.gift-modal .close) {
            opacity: 1;
            color: ${theme.colors.primary};
            border-radius: 50%;
            box-shadow: none;
            text-align: center;
            margin-right: 4px;
            margin-top: 0px;
          }
          :global(.modal-title) {
            font-size: 2em;
          }
        }
      `}</style>
    </>
  );
}

GiftingModal.propTypes = {
  columnSelection: PropTypes.number,
  deal: PropTypes.object,
  isProductPage: PropTypes.bool,
  mainDealGiftButton: PropTypes.object,
  mainDealGiftingChooseYourOptionsButton: PropTypes.any,
  noButton: PropTypes.bool,
  onClose: PropTypes.func,
  position: PropTypes.number,
  rowSelection: PropTypes.number,
  setShowEmptyMessage: PropTypes.func,
  setShowModal: PropTypes.func,
};
